import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  qc_receive_amount,
  withdrawn_amount,
  purchased_amount,
  unit,
  status,
  heat_treatment,
  surface_treatment,
  target_date,
  remarks,
  leadTime,
} from '@/table/Job/SubJob/base';

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    _sizeControls: {
      name: 'ขนาดชิ้นส่วน',
      width: '10rem',
    },
    amount,
    withdrawn_amount,
    purchased_amount,
    qc_receive_amount,
    unit,
    status,
    heat_treatment,
    surface_treatment,
    target_date,
    remarks,
    leadTime,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'withdrawn_amount',
    'purchased_amount',
    'qc_receive_amount',
    'unit',
    'status',
    'heat_treatment',
    'surface_treatment',
    'target_date',
  ],
};
